// 목록 판(활동·검색·스레드·나중에·핀·예약) 줄의 "어디서" 표식.
//
// 채널은 `#`, 비공개 채널은 자물쇠, 대화방은 말풍선이다. 한동안 전부 `#` 여서 대화방이 `# 이하늘` 로 적혀
// 채널처럼 읽혔다(3차 F172). 판마다 종류를 props 로 내려 받으면 여섯 판의 모양이 다 바뀌므로, 판들을 감싼
// 자리(`Side`)가 한 번 심고 표식이 스스로 읽는다. 모르는 번호(나간 채널)는 `#` 다.

import type { ChannelId } from '@maru/protocol'
import { Hash, Lock, MessagesSquare } from 'lucide-react'
import { createContext, use } from 'react'

export type PlaceKind = 'public' | 'private' | 'dm'

export const PlaceKinds = createContext<(channel: ChannelId) => PlaceKind | undefined>(
  () => undefined,
)

/** 줄 목록의 채널 모양으로 종류를 가른다. */
export function place_kind(
  channel: { dm?: boolean | undefined; secret?: boolean | undefined } | undefined,
): PlaceKind | undefined {
  if (channel === undefined) return undefined
  if (channel.dm === true) return 'dm'
  return channel.secret === true ? 'private' : 'public'
}

export function PlaceMark(props: { channel: ChannelId; size?: number }) {
  const kind = use(PlaceKinds)(props.channel)
  const size = props.size ?? 12
  if (kind === 'dm') return <MessagesSquare size={size} aria-hidden />
  if (kind === 'private') return <Lock size={size} aria-hidden />
  return <Hash size={size} aria-hidden />
}
